export default __webpack_public_path__ + "24068df7c054f20c5532123b9ebe0817.png";